<script>
  import noop from 'lodash/noop';
  import ClosableModal from 'root/services/modals/Closable.modal.svelte';
  import RequestToAddHotel from './RbTravelDestinationRequestToAddHotelDialog.svelte'
  import {SvelteDialog} from 'root/v-app/rbServices';

  export let searchData, cancel, onSave = () => {}, onSaveLabel = 'Save';

  let searchString = '';

  $: onSearchStringChange(searchString);

  function onSearchStringChange(ss){
    searchData.search(ss);
    searchData.clearSelected();
  }

  function toggleAdded(hotelId){
    searchData.toggleSelected(hotelId);
  }

  function getSelectedIcon(option, selectedHotels){
    return option.locked ? 'lock' : (selectedHotels.indexOf(option.id) !== -1 ? 'check_box' : 'check_box_outline_blank')
  }

  function requestToAdd(){
    SvelteDialog.show(RequestToAddHotel).catch(noop)
  }
</script>


<ClosableModal close="{cancel}">
  <div slot="heading">
    <div class="Header">
      <div class="HeaderTitle">
        Search Entire Database
      </div>
      <div>If you find your hotel, you may still add it to this destination</div>
    </div>
  </div>

  <div>
    <div class="Input Search">
      <input type="text"
             class="WithIcon"
             id="entityId"
             placeholder="Search for Hotels by Sabre Code, Name or Address"
             name="entity"
             autocomplete="off"
             bind:value={searchString}
      />
      <label for="entityId">Search for Hotels by Sabre Code, Name or Address</label>
      <div class="Icon" data-icon-after="search"></div>
    </div>

    <div class="Menu" >
      <div class="Options">
        {#if $searchData.results && $searchData.results.suggestions }

          {#each $searchData.results.suggestions as r}
            <div class="Option"
                 class:Locked="{r.locked}"
                 class:Selected="{$searchData.selected.indexOf(r.id) !== -1}"
                 data-icon-before="{getSelectedIcon(r, $searchData.selected)}"
                 on:mousedown={() => !r.locked && toggleAdded(r.id)}>
              <div>
                <div class="Title" >{r.name}</div>
                {#if r.sabreCode}
                  <div>Sabre Code: {r.sabreCode || 'NA'} &middot; {r.fullAddress}</div>
                {:else }
                  <div>{r.fullAddress}</div>
                {/if}
              </div>
            </div>
          {/each}

          {#if $searchData.results.hasMore && !$searchData.results.loadingMore}
            <div class="Option Notification">
              <button class="aBtn asLarge asMain atLight"
                      on:mousedown|stopPropagation|preventDefault={() => searchData.more()}>
                More...
              </button>
            </div>
          {/if}
        {/if}

        {#if $searchData.results.loading || $searchData.results.loadingMore}
          <div class="Option Notification">
            <div class="Title">Loading...</div>
          </div>
        {/if}
      </div>

      {#if searchString}
        <div class="NotFound">
          <button class="aBtn atLight asLarge" on:mousedown|preventDefault={requestToAdd}>
            Still cannot find your hotel?
          </button>

          <button class="aBtn atLight asLarge asMain" disabled="{!$searchData.selected.length}" on:mousedown|preventDefault={() => onSave($searchData.selected)}>
            {onSaveLabel}
          </button>
        </div>
      {/if}
    </div>
  </div>
</ClosableModal>

<style lang="stylus">
  .Header {
    padding-left: 14px;
    display: flex;
    height: 63px;
    flex-direction: column;
    justify-content: center;
    font-size: 12px;
    line-height: 20px;
    color: #546E7A;
  }

  .HeaderTitle {
    font-weight: bold;
    font-size: 16px;
    color: #455A64;
  }

  .Input {
    position: relative;
    margin-top: 10px;
    padding: 0 14px;

    input {
      background-color: #ffffff;
      border: 1px solid #CFD8DC;
      border-radius: 6px 6px 6px 6px;

      font-family: "Noto Sans", Sans-serif;
      font-weight: 500;

      color: #37474F;

      font-size: 16px;
      min-height: 47px;
      padding: 6px 16px;

      width: 100%;
      max-width: 100%;

      line-height: 1.4;

      box-sizing: border-box;
      margin: 0;
      outline: none;

      &::placeholder {
        color: inherit;
        font-family: inherit;
        opacity: .6;
      }

      &:placeholder-shown ~ label {
        opacity: 0;
        top: 0;
      }

      & ~ label, & ~ .Icon:after {
        color: #78909C;
      }

      &:focus {
        border-color: #00A99D;

        & ~ label, & ~ .Icon:after{
          color: #00A99D;
        }
      }
    }

    .WithIcon {
      padding-right: 50px;
    }

    label {
      position: absolute;
      box-sizing: border-box;
      background: rgba(255,255,255, 0.8);
      transition: all .2s ease;
      top: -10px;
      left: 10px;
      padding: 0 5px;
      border-radius: 5px;
      font-size: 14px;
      line-height: 1;
      padding-bottom: 4px;
    }

    .Icon {
      position: absolute;
      top: 0;
      right: 14px;
      line-height: 47px;
      width: 40px;

      &:after {
        line-height: inherit;
      }
    }
  }


  .Menu {
    width: 100%;
    color: #90A4AE;
    font-size: 14px;
    line-height: 36px;
    padding: 2px 0;

    margin-top: 15px;
    height: 50vh;
    overflow: hidden;

    display: flex;
    flex-direction: column;

    .Options {
      overflow-y: auto;
      overflow-x: hidden
      flex: 0 1 100%;
    }

    .Option {
      height: 60px;
      color: #B0BEC5;
      font-size: 13px;
      line-height: 15px;
      display: flex;
      background: transparent;
      cursor: pointer;

      &:before {
        flex: 0 0 50px;
      }

      div {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: rgba(144, 164, 174, .5);
      }

      .Title {
        color: #90A4AE;
      }

      &:not(.Locked):hover {
        background: rgba(22, 39, 43, 0.1);
        color: #00A99D;

        .Title {
          color: #00B8AB;
        }
      }

      &.Locked {
        cursor: initial;

        &:before {
          color: #546e7a;
        }
      }

      &.Selected {
        &:before {
          color: #00B8AB;
        }

        .Title {
          color: #00B8AB;
        }
      }

      &.Notification {
        justify-content: center;
        align-items: center;

        &:hover {
          background: inherit;
        }

        .Title {
          color: #00B8AB;
        }
      }
    }

    .NotFound {
      display: flex;
      color: rgba(144, 164, 174, .7);
      padding: 10px;
      font-size: 13px;
      line-height: 15px;
      align-items: flex-end;
      justify-content: space-between;

      flex: 0 0 auto;
    }

    .Title,
    .Selected .Title {
      color: #00B8AB;
      font-size: 14px;
      line-height: 18px;
      margin-bottom: 5px;

      &:before {
        font-size: 20px;
        margin-right: 5px;
      }
    }
  }
</style>
